import { ChangeDetectionStrategy, Component, model, OnInit, inject } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Address, AddressDocumentExport } from '../../../../generated/generated-types';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { AddressDocumentExportService } from '../../services/address-document-export.service';
import { addressDocumentExportFallbackFields } from './address-document-export-fallback-fields';

@Component({
  selector: 'app-address-document-export-edit-widget',
  templateUrl: '../../../../common/base-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  providers: [HotkeysService],
  imports: [
    WidgetBaseDetailComponent
  ]
})
export class AddressDocumentExportEditWidgetComponent extends BaseDetailComponent<AddressDocumentExport> implements OnInit {

  address = model<Address>();
  resetTransferFormat$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  changedTransferFormat$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  cachedModel: AddressDocumentExport;
  existingItemsSig = model<AddressDocumentExport[]>();
  ongoingResetDependingPropertiesSig = model<boolean>(false);

  private service = inject(AddressDocumentExportService);
  protected override crudService = this.service;


  ngOnInit() {
    //just used as Modal so no back to list necessary
    // this.listLink = ListLinks.BANKACCOUNT;
    this.fallbackFields = addressDocumentExportFallbackFields();
    super.ngOnInit();
    //setModel is needed when just passed in as input - otherwise no origModel (Dialog Edit)
    if (!this.modelId())
      this.setModel(this.detailModel);
    this.detailForm.valueChanges.subscribe(async (x: AddressDocumentExport) => {
      this.resetDependingProperties(x);
    });
  }

  resetDependingProperties(model: AddressDocumentExport) {

    if (this.ongoingResetDependingPropertiesSig())
      return;

    this.ongoingResetDependingPropertiesSig.set(true);

    if (model.documentTransferFormat && this.cachedModel?.documentDefinition && model.documentDefinition && this.cachedModel?.documentDefinition?.financeRelevant !== model.documentDefinition?.financeRelevant) {
      this.resetTransferFormat$.next(true);
    }
    if (this.cachedModel?.documentDefinition?.financeRelevant !== model.documentDefinition?.financeRelevant)
      this.changedTransferFormat$.next(true);

    this.cachedModel = model;

    this.ongoingResetDependingPropertiesSig.set(false);
  }

  override async save(detailModel?: Partial<AddressDocumentExport>): Promise<AddressDocumentExport> {
    detailModel = detailModel ?? this.detailModel;
    detailModel.addressId = detailModel.addressId ?? this.address()?.id;
    const docDefId = detailModel.documentDefinitionId ?? detailModel.documentDefinition?.id;
    if (!detailModel.id && this.existingItemsSig().some(x => x.documentDefinitionId === docDefId)) {
      this.baseServices.notificationService.error(_('address-document-export.document-definition-already-exists'));
      this.resolveWith(null);
      return;
    }
    let saved = await super.save(detailModel);
    if (this.resolveWith)
      this.resolveWith(saved);
    return saved;
  }

}
